import React from "react";
import PropTypes from "prop-types";
import Button from "../common/Button";
import { Modal } from "semantic-ui-react";

const ConfirmModal = ({ isOpen, title, mainText, confirmAction, cancelAction, confirmText, cancelText }) => {
	const titleElement = title ? <h2>{title}</h2> : null;

	const scrollYSize = window.parent.scrollY;
	let top = 0;
	const confirmHeight = 220;
	const headerHeight = 314;

	if (window.innerHeight === window.parent.innerHeight) {
		// lokaal
		top = ((window.innerHeight + confirmHeight) / 2);
	}
	else {
		const x = headerHeight - scrollYSize + (confirmHeight / 2);
		top = window.parent.innerHeight / 2 - x;
		top = top > (window.innerHeight - confirmHeight * 2) ? window.innerHeight - confirmHeight * 2 : top;
		top = top < (confirmHeight / 2) ? (confirmHeight / 2) : top;
	}

	const style = { bottom: 'auto', top: top };

	return (
		<Modal
			style={style}
			open={isOpen}>
			<Modal.Content>
				{titleElement}
				<div>{mainText}</div>
			</Modal.Content>
			<Modal.Actions className={"c-form__actions"}>
				<Button onClick={cancelAction} autoFocus text={cancelText} /><Button onClick={confirmAction} text={confirmText} />
			</Modal.Actions>
		</Modal>
	);
};

ConfirmModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	title: PropTypes.string,
	mainText: PropTypes.string.isRequired,
	confirmAction: PropTypes.func.isRequired,
	cancelAction: PropTypes.func.isRequired,
	confirmText: PropTypes.string.isRequired,
	cancelText: PropTypes.string.isRequired
};

export default ConfirmModal;
